"use client"

import { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { Mobile, PC, Notebook, Tablet } from "../../ReactiveMode"
import { RiHome4Fill } from "react-icons/ri"
import { IoIosArrowForward } from "react-icons/io"

const CommonPage = ({ menuList }) => {
    const navigate = useNavigate()
    const location = useLocation()
    const isInitialLoad = useRef(true)

    // clickSubMenuItem을 useState로 관리
    const [clickSubMenuItem, setClickSubMenuItem] = useState(null)
    const [clickSubMenuList, setClickSubMenuList] = useState(null)

    useEffect(() => {
        const [navigationEntry] = window.performance.getEntriesByType("navigation")
        // 브라우저 새로고침인지 확인
        if (navigationEntry && navigationEntry.type === "reload" && isInitialLoad.current) {
            isInitialLoad.current = false // 처음 로드 이후에는 다시 실행되지 않게 설정
            navigate("/")
        } else {
            // 메뉴에서 location.pathname과 일치하는 서브 메뉴 찾기
            let clickSubMenu = menuList.find((item) => item?.children?.some((subItem) => subItem?.url === location.pathname))
            // 일치하는 서브 메뉴가 있을 경우 해당 메뉴의 children을 반환
            if (clickSubMenu) {
                const subMenuItem = clickSubMenu.children.find((item) => item.url === location.pathname)
                setClickSubMenuItem(subMenuItem) // 상태로 설정
                setClickSubMenuList(clickSubMenu.children)
            } else {
                clickSubMenu = menuList.find((item) => item?.url === location.pathname)
                setClickSubMenuItem(clickSubMenu) // 일치하는 메뉴가 없으면 null로 설정
                setClickSubMenuList(null)
            }
        }
    }, [location.pathname]) // menuList와 location.pathname에 의존

    function clickEventHandler(url) {
        navigate(url)
    }

    return (
        <>
            {location.pathname === "/" ? null : (
                <>
                    <PC>
                        <section className="pc-sub-menu-area">
                            <div className={"empty"} />
                            {clickSubMenuItem === undefined ? null : (
                                <div className={"layout"}>
                                    <div className={"path"}>
                                        <div>
                                            <RiHome4Fill /> <IoIosArrowForward />
                                        </div>
                                        {clickSubMenuItem?.preName && (
                                            <>
                                                {clickSubMenuItem?.preName} <IoIosArrowForward />
                                            </>
                                        )}
                                        <div>{clickSubMenuItem?.name}</div>
                                    </div>
                                    <div className={"title"}>{clickSubMenuItem?.name}</div>
                                </div>
                            )}
                        </section>
                    </PC>
                    <Notebook>
                        <section className="pc-sub-menu-area">
                            <div className={"empty"} />
                            {clickSubMenuItem === undefined ? null : (
                                <div className={"layout"}>
                                    <div className={"path"}>
                                        <div>
                                            <RiHome4Fill /> <IoIosArrowForward />
                                        </div>
                                        {clickSubMenuItem?.preName && (
                                            <>
                                                {clickSubMenuItem?.preName} <IoIosArrowForward />
                                            </>
                                        )}
                                        <div>{clickSubMenuItem?.name}</div>
                                    </div>
                                    <div className={"title"}>{clickSubMenuItem?.name}</div>
                                </div>
                            )}
                        </section>
                    </Notebook>
                    <Tablet>
                        <section className="mobile-sub-menu-area">
                            <div className={"empty"} />
                            {clickSubMenuItem === undefined ? null : (
                                <div className={"layout"}>
                                    <div className={"path"}>
                                        <div>
                                            <RiHome4Fill /> <IoIosArrowForward />
                                        </div>
                                        {clickSubMenuItem?.preName && (
                                            <>
                                                {clickSubMenuItem?.preName} <IoIosArrowForward />
                                            </>
                                        )}
                                        <div>{clickSubMenuItem?.name}</div>
                                    </div>
                                    <div className={"title"}>{clickSubMenuItem?.name}</div>
                                </div>
                            )}
                        </section>
                    </Tablet>
                    <Mobile>
                        <section className="mobile-sub-menu-area">
                            <div className={"empty"} />
                            {clickSubMenuItem === undefined ? null : (
                                <div className={"layout"}>
                                    <div className={"path"}>
                                        <div>
                                            <RiHome4Fill /> <IoIosArrowForward />
                                        </div>
                                        {clickSubMenuItem?.preName && (
                                            <>
                                                {clickSubMenuItem?.preName} <IoIosArrowForward />
                                            </>
                                        )}
                                        <div>{clickSubMenuItem?.name}</div>
                                    </div>
                                    <div className={"title"}>{clickSubMenuItem?.name}</div>
                                </div>
                            )}
                        </section>
                    </Mobile>
                </>
            )}
            {(clickSubMenuList?.length === 1 && clickSubMenuList[0]?.url === clickSubMenuList?.url) ||
            clickSubMenuList === null ||
            clickSubMenuList?.length === 0 ||
            location.pathname === "/" ? null : (
                <section className="sub-menu-info">
                    <div className="background">
                        <div className="layout">
                            {clickSubMenuList?.map((menuData, index) =>
                                clickSubMenuItem.url === menuData.url ? (
                                    <div className="sub-menu-active" key={index} onClick={() => clickEventHandler(menuData.url)}>
                                        {menuData?.name}
                                    </div>
                                ) : (
                                    <div className="sub-menu" key={index} onClick={() => clickEventHandler(menuData.url)}>
                                        {menuData?.name}
                                    </div>
                                ),
                            )}
                        </div>
                    </div>
                </section>
            )}
        </>
    )
}

const mapStateToProps = (state) => ({
    clickSubMenuItem: state.menu.clickSubMenuItem,
})

export default connect(mapStateToProps)(CommonPage)
